// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_de-0";